import * as React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';

const StyledToolTips = styled(({ children, className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} arrow disableFocusListener disableTouchListener>
    {children}
  </Tooltip>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.light,
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.light,
  },
}));

export default StyledToolTips;
